import { AppTester, AppTesterType } from "supporting"
import { matchPath, useLocation } from "react-router-dom"
import { LinkTo } from "shared/constants/linkTo";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const getDocumentTitle = ({ title, AppTester, pathname, lang = 'ru' }: { title: string, AppTester: AppTesterType, pathname: string, lang?: string }) => {
    const isProjectPage = matchPath(pathname, LinkTo.project);
    const isProfile = matchPath(pathname, [LinkTo.designer]);
    const isTagPage = matchPath(pathname, LinkTo.tag);

    const titlePostfix = () => {
        if (AppTester.isHseSpace()) {
            return `HSE SPACE`;
        }
        if (AppTester.isLPUDesign()) {
            return 'Lovely Professional University';
        }
        if (AppTester.isCreativeHSE()) {
            return 'Институт развития креативных индустрий';
        }
        if (AppTester.isBrnd()) {
            return 'BRND';
        }
        if (AppTester.isDvaDesign()) {
            return 'DVA Design';
        }
        if (AppTester.isSuperPuper()) {
            return 'Super Puper Games';
        }
        if (AppTester.isAcademy()) {
            return 'Creative city';
        }
        if (AppTester.isGeoDafes()) {
            return 'Dafes';
        }
        if (AppTester.isGeograffee()) {
            return 'Geograffee';
        }
        if (AppTester.isMediiia()) {
            return 'Mediiia';
        }
        if (AppTester.isHSEDesign()) {
            return `HSE Design`;
        }
        if (AppTester.isAgeytomesh()) {
            return 'Agey Tomesh';
        }
        if (AppTester.isGalllleryArt()) {
            return 'Gallllery art';
        }
        if (AppTester.isOnlines()) {
            return 'ONLINES DESIGN SCHOOL';
        }
        if (AppTester.isSchool()) {
            return 'HSE Design';
        }
        if (AppTester.isContinuumSite()) {
            return 'Continuum';
        }
        if (AppTester.isMonaLisaTravels()) {
            return 'Mona Lisa Travels';
        }
        if (AppTester.isHseAnimation()) {
            return 'HSE Animation';
        }
        if (AppTester.isCGRAVE()) {
            return 'CGRave';
        }
        return 'Deziiign';
    }

    const getDivider = () => {
        if (AppTester.isLPUDesign() || AppTester.isCreativeHSE()) {
            return '|'
        }
        return lang === 'ru' ? 'на' : 'on';
    };

    const computeTitle = () => {
        if ((isProjectPage || isProfile) && !!title?.length) {
            return `${title} ${getDivider()} ${titlePostfix()}`
        }
        if (isTagPage && !!title?.length) {
            return `${title} ${'::'} ${titlePostfix()}`
        }
        return title;
    };

    return computeTitle();
}

const useDocumentTitle = (title?: string) => {
    const { i18n: { language: lang } } = useTranslation();
    const { pathname } = useLocation();

    const computedTitle = useMemo(() => {
        if (!title) {
            return undefined;
        }
        return getDocumentTitle({ title, AppTester, pathname, lang });
    }, [title, AppTester, pathname, lang]);

    return computedTitle;
}

export default useDocumentTitle;import { AppTester, AppTesterType } from "supporting"
import { matchPath, useLocation } from "react-router-dom"
import { LinkTo } from "shared/constants/linkTo";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const getDocumentTitle = ({ title, AppTester, pathname, lang = 'ru' }: { title: string, AppTester: AppTesterType, pathname: string, lang?: string }) => {
    const isProjectPage = matchPath(pathname, LinkTo.project);
    const isProfile = matchPath(pathname, [LinkTo.designer]);
    const isTagPage = matchPath(pathname, LinkTo.tag);

    const titlePostfix = () => {
        if (AppTester.isHseSpace()) {
            return `HSE SPACE`;
        }
        if (AppTester.isLPUDesign()) {
            return 'Lovely Professional University';
        }
        if (AppTester.isCreativeHSE()) {
            return 'Институт развития креативных индустрий';
        }
        if (AppTester.isBrnd()) {
            return 'BRND';
        }
        if (AppTester.isDvaDesign()) {
            return 'DVA Design';
        }
        if (AppTester.isSuperPuper()) {
            return 'Super Puper Games';
        }
        if (AppTester.isAcademy()) {
            return 'Creative city';
        }
        if (AppTester.isGeoDafes()) {
            return 'Dafes';
        }
        if (AppTester.isGeograffee()) {
            return 'Geograffee';
        }
        if (AppTester.isMediiia()) {
            return 'Mediiia';
        }
        if (AppTester.isHSEDesign()) {
            return `HSE Design`;
        }
        if (AppTester.isAgeytomesh()) {
            return 'Agey Tomesh';
        }
        if (AppTester.isGalllleryArt()) {
            return 'Gallllery art';
        }
        if (AppTester.isOnlines()) {
            return 'ONLINES DESIGN SCHOOL';
        }
        if (AppTester.isSchool()) {
            return 'HSE Design';
        }
        if (AppTester.isContinuumSite()) {
            return 'Continuum';
        }
        if (AppTester.isMonaLisaTravels()) {
            return 'Mona Lisa Travels';
        }
        if (AppTester.isHseAnimation()) {
            return 'HSE Animation';
        }
        if (AppTester.isCGRAVE()) {
            return 'CGRave';
        }
        return 'Deziiign';
    }

    const getDivider = () => {
        if (AppTester.isLPUDesign() || AppTester.isCreativeHSE()) {
            return '|'
        }
        return lang === 'ru' ? 'на' : 'on';
    };

    const computeTitle = () => {
        if ((isProjectPage || isProfile) && !!title?.length) {
            return `${title} ${getDivider()} ${titlePostfix()}`
        }
        if (isTagPage && !!title?.length) {
            return `${title} ${'::'} ${titlePostfix()}`
        }
        return title;
    };

    return computeTitle();
}

const useDocumentTitle = (title?: string) => {
    const { i18n: { language: lang } } = useTranslation();
    const { pathname } = useLocation();

    const computedTitle = useMemo(() => {
        if (!title) {
            return undefined;
        }
        return getDocumentTitle({ title, AppTester, pathname, lang });
    }, [title, AppTester, pathname, lang]);

    return computedTitle;
}

export default useDocumentTitle;